<template>
  <div></div>
</template>

<script>
export default {
  name: "fail"
}
</script>

<style scoped>

</style>